module.exports = __webpack_public_path__ + "assets/img/house-fancy.903cd36f.jpg";